'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCogOutline = function TiCogOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 8.3l1.4 5.7 5.6-1.6 2.5 4.3-4.2 4.1 4.2 4.1-2.5 4.3-5.6-1.6-1.4 5.7h-5l-1.5-5.7-5.6 1.6-2.5-4.3 4.2-4.1-4.2-4.1 2.5-4.3 5.6 1.6 1.5-5.7h5z m0-3.3h-5c-1.6 0-2.9 1-3.3 2.5l-0.6 2.4-2.3-0.7c-0.3-0.1-0.6-0.1-0.9-0.1-1.2 0-2.3 0.6-2.9 1.7l-2.5 4.3c-0.8 1.3-0.5 3 0.6 4l1.7 1.7-1.7 1.7c-1.1 1.1-1.4 2.8-0.6 4.1l2.5 4.3c0.6 1.1 1.7 1.7 2.9 1.7 0.3 0 0.6-0.1 0.9-0.1l2.3-0.7 0.6 2.3c0.4 1.5 1.7 2.6 3.3 2.6h5c1.5 0 2.8-1.1 3.2-2.6l0.6-2.3 2.3 0.6c0.3 0.1 0.6 0.2 0.9 0.2 1.2 0 2.3-0.6 2.9-1.7l2.5-4.3c0.8-1.4 0.6-3-0.5-4.1l-1.8-1.7 1.8-1.7c1.1-1 1.3-2.7 0.5-4l-2.5-4.4c-0.6-1-1.7-1.6-2.9-1.6-0.3 0-0.6 0-0.9 0.1l-2.3 0.7-0.6-2.4c-0.4-1.5-1.7-2.5-3.2-2.5z m-2.5 12.5c1.8 0 3.3 1.5 3.3 3.3 0 1.9-1.5 3.4-3.3 3.4s-3.4-1.5-3.4-3.4c0-1.8 1.5-3.3 3.4-3.3z m0-1.7c-2.8 0-5 2.3-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5z' })
        )
    );
};

exports.default = TiCogOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cog-outline.js
// module id = 3562
// module chunks = 0